import React, { useEffect } from 'react';
import Spinner from "@/components/elements/Spinner";
import { redirectAfterLogout } from "@/actions";
import { useAppDispatch } from '@/hooks';

interface Props {  }

const Auth: React.FC<Props> = (props) => {
    const dispatch = useAppDispatch();
    
    useEffect(() => {
        dispatch(redirectAfterLogout());
      }, [])
      
    return (
        <Spinner noGraceTime />
    );
};

export default Auth;
